import React from 'react';
import { Slide } from 'react-slideshow-image';
import imgSign from '../images/sign.jpg';
import imgTable from '../images/table.jpg';
import imgGarden from '../images/garden.jpg';
import imgDesk from '../images/desk.jpg';
import imgFlower from '../images/flower.jpg';

const SlideShow = () => {
  return (
    <Slide
      images={[imgSign, imgTable, imgGarden, imgDesk, imgFlower]}
      duration={4000}
      transitionDuration={500} />
  );
};

export default SlideShow;



// WEBPACK FOOTER //
// ./src/components/SlideShow.js